import React from 'react';

const Terms = () => {
  return (
    <div>
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container" style={{ maxWidth: '900px' }}>
          <h1 className="hero-medium" style={{ marginBottom: '48px' }}>Terms & Conditions – Delhi Guided Tours</h1>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              Delhi Guided Tours ("we", "us", "our") provides guided heritage tours, private sightseeing experiences, and multi-day travel itineraries in and around New Delhi, India.
            </p>
            
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              By using our website or participating in any tour, you agree to the following terms:
            </p>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>1. Nature of Services</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Delhi Guided Tours offers guided tours and travel facilitation services. We do not own or control monuments, transportation systems, or third-party facilities.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>2. Bookings & Participation</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                All bookings are subject to availability. Guests must arrive at the meeting point 10–15 minutes before the scheduled start time. Tours start on time, and late arrivals may not be accommodated.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>3. Entry Tickets</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Unless stated otherwise, monument entry tickets are not included and must be purchased separately by guests.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>4. Guest Responsibility</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Guests are responsible for their belongings and must follow monument rules and guide instructions. Delhi Guided Tours is not liable for loss, injury, or damage beyond reasonable control.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>5. Changes</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                Tours may be modified or cancelled due to weather, security restrictions, monument closures, or unforeseen circumstances.
              </p>
            </div>

            <div>
              <h2 className="heading-2" style={{ marginBottom: '16px' }}>6. Governing Law</h2>
              <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                These terms are governed by the laws of India, with jurisdiction in New Delhi.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Terms;